import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useModal } from '@shared/lib'

export const useResultModal = () => {
  const router = useRouter()

  const { isModalActive, handleModalOpen, handleModalClose } = useModal()

  useEffect(() => {
    if (router.query.requestId || router.query.mdOrder) {
      handleModalOpen()
    }
  }, [router.query.requestId, router.query.mdOrder])

  return { isResultModalActive: isModalActive, handleResultModalClose: handleModalClose }
}
